import App from './App.vue';
import appInit from "../shared/app-init-element";
import { library as faLibrary } from '@fortawesome/fontawesome-svg-core'
import { faCaretRight, faStar } from '@fortawesome/pro-solid-svg-icons'

faLibrary.add(faCaretRight, faStar);

let elements = document.getElementsByTagName('adsCarouselApp');
let arr = Array.prototype.slice.call(elements);

arr.forEach((el) => {
  appInit(App, el, true);
});